import React from "react";
import themePropTypes from "../theme-prop-types";
import Text from "./text";
import HorizontalRule from "./horizontal-rule";

const Doctor = ({
  fullName,
  phone_number,
  pcp = false,
  specialties,
  settings
}) => (
  <>
    <Text label={fullName} />
    <Text label={specialties} />
    <Text label={phone_number} />
    <Text label={pcp ? settings.translations.primary_care_physician : ""} />
    <HorizontalRule />
  </>
);

Doctor.propTypes = themePropTypes.doctor;

export default Doctor;
